import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/plugins/element.js'
import VueSession from 'vue-session'
import axios from 'axios'
import LoadingMask from '@/plugins/LoadingMask.js'
import FcMessage from '@/plugins/FcMessage.js'
import DefaultBillingYm from '@/mixins/DefaultBillingYm.vue'
import OwnAirport from '@/mixins/OwnAirport.vue'
import LoginUserInformation from '@/plugins/LoginUserInformation.js'
import PasswordCommon from '@/mixins/PasswordCommon.vue'
import TableCommon from '@/mixins/TableCommon.vue'
import awsconfig from '@/plugins/aws-exports.js'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'

Amplify.configure(awsconfig)
Vue.use(VueSession)
Vue.config.productionTip = false
Vue.use(AmplifyPlugin, AmplifyModules)

axios.defaults.baseURL = process.env.VUE_APP_DEFAULTS_BASEURL
axios.defaults.headers.common['X-PINGOTHER'] = 'pingpong'

const instance = axios.create()

instance.interceptors.request.use(
  async request => {
    try {
      const session = await Amplify.Auth.currentSession()
      // セッションの取得成功
      request.headers.common.Authorization = session.getIdToken().jwtToken
      return request
    } catch (error) {
      // alert('err1')
      router.push({ name: 'SystemError', params: { status: '400', message: error } })
      return Promise.reject(error)
    }
  },
  error => {
    // alert('err2')
    router.push({ name: 'SystemError', params: { status: '400', message: error } })
    return Promise.reject(error)
  }
)
instance.interceptors.response.use(
  response => {
    if (response.data.list) {
      if (response.data.list.recordheader) {
        const header = response.data.list.recordheader
        const body = response.data.list.recordbody
        response.data.list = body.map(x => {
          const row = {}
          x.forEach((y, i) => { row[header[i]] = y })
          return row
        })
      }
    }
    return response
  },
  error => {
    if (error.response === undefined) {
      router.push({ name: 'SystemError', params: { status: 'undifined', message: error.message } })
      return
    } else {
      // if (error.response.status === 401 || error.response.status >= 500) {
      if (error.response.status === 400 || error.response.status === 403 || error.response.status === 401 || error.response.status >= 500) {
        router.push({ name: 'SystemError', params: { status: error.response.status, message: error.response.data } })
        return
      }
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$axios = instance
Vue.use(LoadingMask)
Vue.use(FcMessage)
Vue.mixin(DefaultBillingYm)
Vue.mixin(OwnAirport)
Vue.use(LoginUserInformation)
Vue.mixin(PasswordCommon)
Vue.mixin(TableCommon)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
